<template>
  <Layout>
    <!-- ICON -->
    <template #icon>table_chart</template>

    <!-- TITLE -->
    <template #title>{{ $t('PartsResults.Title') }}</template>

    <template #menu>
      <v-flex shrink v-if="specificConditionsQuestions.length">
        <v-btn v-if="$isDesktopDevice" color="primary" @click="openSCQ">
          <v-icon left class="subPrimary--text">list_alt</v-icon>
          <span class="subPrimary--text font-weight-light text-capitalize">{{ $t("Menu.SpecificConditions")
          }}</span>
        </v-btn>
        <v-btn v-if="$isMobileDevice" fab small dark color="primary" @click="openSCQ">
          <v-icon medium color="SubPrimary">list_alt</v-icon>
        </v-btn>
      </v-flex>

      <v-flex shrink v-if="partListBasket.length">
        <v-btn v-if="$isDesktopDevice" color="primary" @click="print(selected_parts)">
          <v-icon left class="subPrimary--text">file_download</v-icon>
          <span class="subPrimary--text font-weight-light text-capitalize ml-1">{{ $t("Menu.PrintPdf") }}</span>
        </v-btn>
        <v-btn v-if="$isMobileDevice" fab small dark color="primary" @click="print(selected_parts)">
          <v-icon medium color="subPrimary">file_download</v-icon>
        </v-btn>
      </v-flex>
    </template>
    <template #body>
      <TableDesktop v-if="!$isPhoneDevice" />
      <TableMobile v-if="$isPhoneDevice" />
    </template>

  </Layout>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { print } from '@/utils';


export default {
  name: "Result",
  components: {
    Layout: () => import("@/layouts/Layout.desktop"),
    TableDesktop: () => import("../../components/Parts/Table.desktop.vue"),
    TableMobile: () => import("../../components/Parts/Table.mobile"),
  },
  computed: {
    ...mapState({
      returnPage: state => state.settings.partsResultPage,
      groups: state => state.parts.groups,
      skin: state => state.settings.skin,
      logoUrl: state => state.settings.skin.logo_url,
      partListBasket: state => state.parts.partListBasket
      // specificConditionsQuestions: state => state.specificConditionsQuestions,
    }),
    ...mapGetters({
      selectedVehicleText: 'vehicle/selectedVehicleText',
      specificConditionsQuestions: 'parts/specificConditionsQuestions'
    }),
    selected_parts() {
      let selected = [];

      this.partListBasket.forEach(part => {          
          selected.push(
            [{ content: '', rowSpan: 2 }, { content: part.description, styles: { textColor: this.skin.primary_color } }, { content: part.mfgCode }, { content: part.partNum }, { content: part.years }, { content: part.qty }, part.thumbnailURL],
          );

          selected.push([
            {
              content: part.info,
              colSpan: 5,
              styles: { fillColor: 'white', textColor: '#969696' }
            }
          ]);
      });

      return selected;
    }
  },
  methods: {
    ...mapActions({
      TOGGLE_MODAL_STATE: "modals/TOGGLE_MODAL_STATE",
      RESET_PARTS: "parts/RESET_PARTS",
    }),
    openSCQ() {
      this.TOGGLE_MODAL_STATE({ name: 'SCQ', value: true });
    },
    print
  },
  deactivated() {
    this.RESET_PARTS();
  }
};
</script>